const config = {
  // // Localhost
  // API_BASE_URL: "http://localhost:3001/",
  // IMAGE_URL: "http://localhost:3001/",
  // APP_URL: "http://localhost:3000/",
  

  // IMAGE_URL: "http://localhost:3001/uploads/",
  Captcha_SiteKey: "6LetgBkrAAAAABFE9c665MpB2IOnDYh0lRXWt3Zg",

  // production
  API_BASE_URL: "https://bk.circulatehealthcare.com:3445/",
  IMAGE_URL: "https://bk.circulatehealthcare.com:4443/",
  APP_URL: "https://application.hrglobes.com/"
};

export default config;
